import { motion, type Variants } from "framer-motion";
import { useLocation } from "react-router-dom";
import { ReactNode } from "react";

const pageVariants: Variants = {
  initial: { opacity: 0, y: 6 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.2, ease: [0.25, 0.1, 0.25, 1] as [number, number, number, number] },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.1 },
  },
};

interface PageTransitionProps {
  children: ReactNode;
  isFixedHeight?: boolean;
}

export function PageTransition({ children, isFixedHeight }: PageTransitionProps) {
  const location = useLocation();

  return (
    <motion.div
      key={location.pathname}
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className={isFixedHeight ? "flex flex-col h-full min-h-0 overflow-hidden" : "flex-1 min-h-0"}
    >
      {children}
    </motion.div>
  );
}
